import { UserRound } from "lucide-react";

import Dropdown, { DropdownProps } from "../dropdown/dropdown";
import { cn } from "@/lib/utils";
import LogoutCustomer from "@/components/templates/Account/components/logout-customer";
import { Locales } from "@/lib/i18n";

type UserMenuProps = {
  links: DropdownProps["links"];
  dropdownContentAlign: DropdownProps["dropdownContentAlign"];
  className: DropdownProps["className"];
  defaultOpen: DropdownProps["defaultOpen"];
  locale: Locales;
};

const UserMenu = ({ links, dropdownContentAlign, defaultOpen, className, locale }: UserMenuProps) => {
  return (
    <Dropdown
      defaultOpen={defaultOpen}
      className={cn("gap-1 border-none", className)}
      dropdownContentAlign={dropdownContentAlign}
      links={links}
      footerItem={<LogoutCustomer isInNavbar locale={locale} />}
    >
      <UserRound />
    </Dropdown>
  );
};

export default UserMenu;
